import React from 'react';
import AtlasV2MetricListContainer, {
  AtlasV2MetricListContainerProps
} from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricListContainer';
import { ProductColumnDefinition } from 'src/components/BeaconV2Components/MetricList/headColumnDefinitions';
import ProductGrid, { ProductGridProps } from 'src/components/BeaconV2Components/ProductGrid/ProductGrid';

export interface PaginationRequestOverride {
  termFilters: { fieldName: string; condition: string; values: (string | number)[] }[];
  rangeFilters: { fieldName: string; minValue: number; maxValue: number }[];
}

type AtlasV2ProductListContainerProps = Pick<
  AtlasV2MetricListContainerProps,
  | 'indexName'
  | 'fields'
  | 'sortFieldName'
  | 'mainFieldName'
  | 'entityTableHeaderProps'
  | 'showGrid'
  | 'forceGrid'
  | 'useTableDataProps'
  | 'columnDefinitions'
  | 'postProcessData'
  | 'onChangePage'
  | 'buildRequest'
  | 'groupBy'
  | 'iconList'
  | 'showHeader'
  | 'appTableProps'
  | 'customDataSource'
  | 'showSortOptions'
  | 'shouldHidePagination'
  | 'sortOption'
  | 'onSortOptionChange'
> & {
  productGridProps?: Partial<ProductGridProps>;
} & Partial<Pick<AtlasV2MetricListContainerProps, 'headColumnDefinition' | 'loading'>>;

/**
 * Wrapper around the MetricListContainer to specifically render
 * a list of products by a given set of metrics
 */
export default function AtlasV2ProductListContainer({
  productGridProps,
  headColumnDefinition = ProductColumnDefinition,
  ...rest
}: AtlasV2ProductListContainerProps) {
  return (
    <AtlasV2MetricListContainer
      headColumnDefinition={headColumnDefinition}
      renderGrid={(args) => <ProductGrid {...args} {...productGridProps} />}
      {...rest}
    />
  );
}
